import { Injectable } from "@angular/core";
import { Store } from "@modules/core/store/store.model";
import { StopSearchResult, EffectedRoutesOnStop } from "../components/search-stop/interfaces";
import { LineTripSearchResult } from "../components/search-route-and-trip/interfaces/line-trip-search-result";
import { distinctUntilChanged, map } from "rxjs";

export interface SearchState {
    selectedHastusRegion: string;
    cachedQueryResults?: StopSearchResult[];
    cachedQueryString: string;
    selectedStopSearches: StopSearchResult[];
    selectedRoutes: LineTripSearchResult[];
    platformRoutesCache: Map<string, EffectedRoutesOnStop[]>;
}

const initialState: SearchState = {
    selectedHastusRegion: '',
    cachedQueryResults: undefined,
    cachedQueryString: '',
    selectedStopSearches: [],
    selectedRoutes: [],
    platformRoutesCache: new Map()
};

@Injectable({
    providedIn: 'root'
})
export class TrafficDeviationSearchStore extends Store<SearchState> {

    constructor() {
 super(initialState); 
}

    public getSelectedHastusRegion() {
        return this.state$.pipe(
            map(state => state?.selectedHastusRegion),
            distinctUntilChanged(),
        );
    }

    public getCachedQueryResults() {
        return this.state$.pipe(
            map(state => state?.cachedQueryResults),
            distinctUntilChanged(),
        );
    }

    public getSelectedStopSearches() {
        return this.state$.pipe(
            map(state => state?.selectedStopSearches),
            distinctUntilChanged(),
        );
    }

    public getSelectedRoutes() {
        return this.state$.pipe(
            map(state => state?.selectedRoutes),
            distinctUntilChanged(),
        );
    }

    public resetSearchState(): void {
        this.setState(structuredClone(initialState));
    }

    public updateSearchState(state: Partial<SearchState>): void {
        if(!state) return;
        this.patchState(state);
    }

    public setPlatformRoutes(placeId: string, hastusRegion: string, routes: EffectedRoutesOnStop[]): void {
        const currentCache = this.stateSnapshot.platformRoutesCache;
        const newCache = new Map(currentCache);
        const cacheKey = `${placeId}|${hastusRegion}`;
        newCache.set(cacheKey, routes);
        this.patchState({ platformRoutesCache: newCache });
    }

    public getPlatformRoutes(placeId: string, hastusRegion: string): EffectedRoutesOnStop[] | undefined {
        const cacheKey = `${placeId}|${hastusRegion}`;
        return this.stateSnapshot.platformRoutesCache.get(cacheKey);
    }

    public clearPlatformRoutesCache(): void {
        this.patchState({ platformRoutesCache: new Map() });
    }

    public setSearchState(state: SearchState): void {
        if(!state) return;
        this.setState(state);
    }
}